const characterList = state => {
  return state.characterList
}

const totalCount = state => {
  return state.totalCount
}

const totalPageCount = state => {
  return state.totalPageCount
}

const pageNo = state => {
  return state.pageNo
}

const pageSize = state => {
  return state.pageSize
}

const selectedCharacter = state => {
  return state.selectedCharacter
}

const sortType = state => {
  return state.sortType
}

export default {
  characterList,
  selectedCharacter,
  totalCount,
  totalPageCount,
  pageNo,
  pageSize,
  sortType
}
